//COLORS PALETTE FOR INDRA
import { withStyles } from '@material-ui/core'

export const indraEnabled = true
export const boardIcon = '#000000'

export const muiPaletteOverride = {
  text: {
    primary: '#004254',
    secondary: '#03657C'
  },
  primary: {
    light: '#b2efd2',
    main: '#004254',
    dark: '#004254',
    contrastText: '#fff'
  },
  secondary: {
    light: '#ffd54f',
    main: '#ffc107',
    dark: '#ff8f00',
    contrastText: '#212121'
  }
}

export const success = {
  light: '#91e573',
  main: '#00e676',
  dark: '#30d786'
}

export const buttonColor = 'white'
export const toolbarColor = '#004254'
export const percentageProcessTable = '#004254'
export const percentageProcessTableNumber = '#FABB21'

//actionButton Primary Colors
export const actionButtonBackgroundColor = 'transparent'
export const actionButtonBackgroundHoverColor = '#FABB21'
export const actionButtonBorderColor = '#FABB21'
export const actionButtonFontColor = '#FABB21'
export const actionButtonFontHoverColor = '#000000'

//actionButton Secondary Colors
export const actionButtonBackgroundSecondaryColor = 'transparent'
export const actionButtonBackgroundHoverSecondaryColor = '#FABB21'
export const actionButtonBorderSecondaryColor = '#FABB21'
export const actionButtonFontSecondaryColor = '#FABB21'
export const actionButtonFontHoverSecondaryColor = '#000000'

//Button Primary Colors
export const ButtonBackgroundColor = 'transparent'
export const ButtonBackgroundHoverColor = '#FABB21'
export const ButtonBorderColor = '#FABB21'
export const ButtonFontColor = '#FABB21'
export const ButtonFontHoverColor = '#000000'

export const ButtonNotRaisedBackgroundColor = 'transparent'
export const ButtonNotRaisedBackgroundHoverColor = '#F7F3E6'
export const ButtonNotRaisedBorderColor = '#FABB21'
export const ButtonNotRaisedFontColor = '#FABB21'
export const ButtonNotRaisedFontHoverColor = '#FABB21'

//Button Secondary Colors
export const ButtonBackgroundSecondaryColor = 'transparent'
export const ButtonBackgroundHoverSecondaryColor = '#FABB21'
export const ButtonBorderSecondaryColor = '#FABB21'
export const ButtonFontSecondaryColor = '#FABB21'
export const ButtonFontHoverSecondaryColor = '#000000'

//Titles and Headings Font Color
export const loginHeaderBarColor = 'rgba(0, 66, 84,0.8)'
export const headerBarColor = '#004254'
export const title = '#004254'
export const headerTable = '#03657C'
export const dataTable = '#004254'

//Pie Chart Colors
export const FinishedItemsColor = '#004254'
export const PendingItemsColor = '#37AAB2'
export const OnGoingItemsColor = '#FBBB21'

const s = window.document.createElement('style')
s.innerHTML = `
span[class*='MuiCheckbox-checked'] svg {
  color: #004254 !important;
}

button[class*='MuiButton-text'] {
  text-transform: capitalize !important;
  border-radius: 3px !important;
  border: 1px solid #FBBB21 !important;
  background: none !important;
}

button[class*='MuiButton-raised'] {
  text-transform: capitalize !important;
  border-radius: 3px !important;
  border: 1px solid #FBBB21 !important;
  background: none !important;
  box-shadow: none !important;
}

button span {
  color: #004254 !important;
}

#indra-login {
  background: #004254 !important;
  border: none !important;
}

#indra-login span {
  color: white !important;
  font-size: 1.3em !important;
}

header button svg {
  color: white !important;
}

button[class*='MuiButton-text']:hover {
  background: #FBBB21 !important;
}

button[class*='MuiButton-raised']:hover {
  background: #FBBB21 !important;
}

div[role="radiogroup"] path{
  color: ${muiPaletteOverride.text.primary} !important;
}

span[class*='MuiCardHeader-title'] {
  font-size: 1.2rem;
}
`
window.document.head.appendChild(s)


// WEBPACK FOOTER //
// ./src/theme.js